import { render, staticRenderFns } from "./TeamView.vue?vue&type=template&id=2b7505b9&scoped=true&"
import script from "./TeamView.vue?vue&type=script&lang=js&"
export * from "./TeamView.vue?vue&type=script&lang=js&"
import style0 from "./TeamView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TeamView.vue?vue&type=style&index=1&id=2b7505b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7505b9",
  null
  
)

export default component.exports